<template>
  <Modal class-name="vertical-center-modal" v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">{{(this.labelType===0) ? '空置跟进':'即将退租跟进'}}</div>
    <Form :model="formData" :label-width="0"  :rules="formRules" ref="formData">
      <FormItem prop="remark">
        <Input
          :rows="4"
          type="textarea"
               :maxlength="150" placeholder="请录入跟进内容，不超过150字"
               v-model="formData.remark"

        ></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="close">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading" >
          <span v-if="!loading" >确定</span>
          <span v-else>保存中...</span>
        </Button>
      </div>
    </div>

  </Modal>
</template>

<script type="text/ecmascript-6">
import { saveForRentFollow } from 'api/house'

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    labelType:{
      type:Number,
      default:null
    },
    labelUnique:{
      type:String,
      default:''
    }
  },
  watch:{
    n(val) {
      this.show = true
      this.$refs['formData'].resetFields();
    }
  },
  data() {
    return {
      loading:false,
      show: false,
      formData:{
        remark:''
      },
      formRules:{
        remark:[{ required: true, message:'请录入跟进内容', trigger: "blur" }]
      }
    }
  },
  methods:{
    close(){
      this.show = false
    },
    save() {
    // 调接口
     this.$refs[`formData`].validate(bool => {
       if(bool) {
         let data = {
           labelUnique:this.labelUnique,
           remark:this.formData.remark,
           labelType:this.labelType
         }
         this.loading = true
         saveForRentFollow(data).then(res => {
           this.loading = false
            this.$Message.success('操作成功！')
            this.show = false
            this.$emit('refresh')
          }).catch( err => {
            this.loading = false
          })

       }
     })

    }

  }
}
</script>
